/**
 * 在请求拦截器中刷新token
 */
// 导入axios
import ax from "axios";
import { MessageBox } from 'element-ui';
import store from "@/store";
import commonParam from "@/param/commonParam";
import { TOKEN, REFRESH_TOKEN, TOKEN_TIME } from "@/param/method_param";
import router from "@/router";

const instance = ax.create({
  baseURL: commonParam.serverUrl,
  timeout: 30000,
});

// 从vuex缓存中获取 tokenInfo 与 tokenTime
function getTokenInfo() {
  let tokenInfo = {};
  try {
    tokenInfo[TOKEN] = store.state.personOptions.tokenInfo.access_token || '';
    tokenInfo[REFRESH_TOKEN] = store.state.personOptions.tokenInfo.refresh_token || '';
    tokenInfo[TOKEN_TIME] = store.state.personOptions.tokenTime || 0;
  } catch {
    console.error('get token from localStorage error');
  }
  return tokenInfo;
}

// 刷新token接口
async function refreshToken(refresh_token) {
  // instance 是当前 request.js 中已创建的 axios 实例
  const resp = await instance.post('/uaa/authLogin', { "grant_type": "refresh_token", "refresh_token": refresh_token });
  return resp.data;
}

// 登录后将最新 token 动态添加到 header，同时将 token 保存在本地缓存中
instance.setToken = (tokenInfo) => {
  instance.defaults.headers['Authorization'] = 'Bearer ' + tokenInfo.access_token;
  store.dispatch('personOptions/setTokenInfo', tokenInfo)
}

function tokenUtil(config, tokenInfo) {
  config.headers['Authorization'] = 'Bearer ' + tokenInfo[TOKEN];
  const nowTime = new Date().getTime(); // 现在时间
  const tokenTime = tokenInfo[TOKEN_TIME]; // 登录时token记录时间
  const timePeriod = nowTime - tokenTime;
  // 立即刷新token
  if (timePeriod > commonParam.tokenOverTime && timePeriod < commonParam.refreshTokenOverTime) {
    if (!isRefreshing) {
      isRefreshing = true;
      refreshToken(tokenInfo[REFRESH_TOKEN]).then(resp => {
        instance.setToken(resp);
        isRefreshing = false;
        return resp.access_token;
      }).then(token => {
        requests.forEach(cb => cb(token));
        // 执行完成后，清空队列
        requests = [];
      }).catch(res => {
        console.error('refresh token error: ', res);
      });
    }
    const retryOriginalRequest = new Promise((resolve) => {
      requests.push((token) => {
        config.headers['Authorization'] = 'Bearer ' + token;
        resolve(config);
      });
    });
    return retryOriginalRequest;
  } else if (timePeriod > commonParam.refreshTokenOverTime) {
    MessageBox.confirm('登录已过期，请重新登录', '温馨提示', {
      type: 'warning',
      showClose: false,
      showCancelButton: false,
      closeOnClickModal: false,
      closeOnPressEscape: false,
    }).then(() => {
      store.dispatch('personOptions/setResetState');
      router.push('/supplierAllBack');
      return Promise.reject('重新登录');
    }).catch(() => {});
  } else {
    return config;
  }
}

// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []

// 请求拦截器
instance.interceptors.request.use((config) => {
  const tokenInfo = getTokenInfo();
  if (config.needToken) {
    if (tokenInfo[TOKEN] && tokenInfo[REFRESH_TOKEN] && tokenInfo[TOKEN_TIME]) {
      return tokenUtil(config, tokenInfo);
    } else {
      MessageBox.confirm('尚未登录，请前往登录', '温馨提示', {
        type: 'warning',
        showClose: false,
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
      }).then(() => {
        router.push('/supplierAllBack');
        return Promise.reject('尚未登录');
      }).catch(() => {});
    }
  } else if (config.defaultToken) {
    if (tokenInfo[TOKEN]) {
      return tokenUtil(config, tokenInfo);
    } else {
      return config;
    }
  } else {
    return config;
  }
}, (error) => {
  return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use(async (response) => {
  return response.data;
}, (error) => {
  return Promise.reject(error); // 接口500抛出异常（不走页面逻辑）
});

export default instance;
